import React, { useContext } from 'react';
import { Typography } from '@material-ui/core';
import Lottie from 'react-lottie';
import * as animationData from './first_checked.json';
export default function order_sent({ history, desktop, messenger_user_id }) {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  if (desktop || messenger_user_id) {
    setTimeout(() => {
      history.push('/history');
    }, 3000);
  }

  return (
    <div>
      <Lottie options={defaultOptions} height={400} width={400} />
      <Typography variant='title' align='center'>
        Your order has been received successfully!
      </Typography>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/order_sent.js